import { List, Tooltip } from 'antd';
import React from 'react';
import { ObterComentarioPorLinhaSlaId } from '@app/api/sla';
import { usePromise, Button, Icon } from '@digital/ui';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagem(props: any) {
  const [getAllMensagem] = usePromise(
    () => (props.linhaSlaId ? ObterComentarioPorLinhaSlaId(props.linhaSlaId) : Promise.resolve(undefined)),
    [props.recarregarMensagem],
    [],
  );

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={getAllMensagem}
        renderItem={item => (
          <List.Item>
            {item.possuiArquivo ? (
              <List.Item.Meta
                title={
                  <a href="#">
                    {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                  </a>
                }
                description={<>{item.mensagem}</>}
                className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
              />
            ) : (
              <List.Item.Meta
                title={
                  <a href="#">
                    {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                  </a>
                }
                description={item.mensagem}
                className={item.mrn ? 'classeMrn' : 'classeFornecedor'}
              />
            )}
          </List.Item>
        )}
      />
    </div>
  );
}
